<style>
  .preview-select pre {
    font-family: monospace, monospace;
    /*font-size: 1em;*/
    display: block;
    padding: 9.5px;
    margin: 0 0 10px;
    font-size: 13px;
    line-height: 1.42857143;
    color: #333;
    word-break: break-all;
    word-wrap: break-word;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .preview-select pre.ql-syntax {
    background-color: #23241f;
    color: #f8f8f2;
    overflow: visible;
  }
  .preview-select blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }
  .preview-select .ql-align-right {
    text-align: right;
  }
  .preview-select .ql-align-center {
    text-align: center;
  }
  .preview-select iframe.ql-align-center {
      margin-left: 400px;
    }
  .preview-select iframe.ql-align-right {
    margin-left: 800px;
  }
  .preview-select .ql-editor .ql-align-right {
    text-align: right;
  }
  .preview-select li:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
  }
  .preview-select .ql-size-huge {
    font-size: 2.5em;
  }
  .preview-select .ql-size-large {
    font-size: 1.5em;
  }
  .preview-select .ql-size-small {
    font-size: 0.75em;
  }
  .preview-select .ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
  }
  .preview-select .ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
  }
  .preview-select ol {
    padding-left: 20px;
    list-style-type:decimal;
    list-style-position:inside;
  }
  .preview-select ul {
    list-style-type:disc;
    list-style-position:inside;
  }
  .preview-header {
    position: relative;
    height: 88px;
    line-height: 88px;
    background: #ffffff;
  }
  .container{
    width: 1200px;
    margin: 0 auto;
  }
  .preview-header .right  a {
    font-size: 18px;
    color: #666666;
    height: 88px;
    text-decoration: none;
  }
  .preview-header .right  a:first-child{
    margin-right: 20px;
  }
  .preview-header a img {
    padding-right: 7px;
  }
  .preview-header-content .row{
    margin: 0;
  }
  .preview-header .logo img {
    vertical-align: middle;
  }
  .preview-header h2 {
    display: inline-block;
    vertical-align: middle;
    border-left: 1px solid #999999;
    padding: 0 23px 0 10px;
    height: 50px;
    line-height: 25px;
  }
  .preview-header  h2 span {
    font-size: 14px;
    color: #999999;
    vertical-align: text-top;
  }
  .preview-header .right{
    padding: 0;
    text-align: right;
  }
  .preview-header .nav{
    float: right;
    height: 88px;
    line-height: 100px;
  }
  .preview-header .nav li{
    float:left;
    font-size:20px;
    margin-left:10px;
  }
  .preview-header .nav li a{
    cursor:pointer;
    padding:0 20px 0 10px;
    line-height: 100px;
    font-weight: normal;
  }
  .preview-header .nav li a img{
    margin-right: 7px;
    vertical-align: text-bottom;
  }
  .preview-navbar-default{
    border-color: #f1f1f1;
    background: #f1f1f1;
  }
  .preview-header-wrapper {
    position: fixed;
    width: 100%;
    top: 0;
    background: #ffffff;
    z-index: 20;
    border-bottom: 1px solid #eee;
  }
  .preview-select img{max-width:100%;}
  audio.ql-align-center {
    margin-left: 300px;
  }
  audio.ql-align-right {
    margin-left: 800px;
  }
</style>
<template>
  <div>
    <div class="preview-header">
      <nav class="preview-header-wrapper preview-navbar preview-navbar-default preview-navbar-fixed-top">
        <div class="preview-header-content container">
          <div class="row">
            <div class="col-sm-6 logo">
              <a href="#"><img src="/static/logo.png" alt="hellokid"></a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  <div style="width: 1100px;margin: auto;white-space:pre;margin-top: 40px">
    <div class="preview-select" v-html="data">
    </div>
  </div>
  </div>
</template>
<script>
  export default {
    name: 'LessonPreviewModal',
    props: {
      previewData: {
        type: String,
        default: ''
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        visible: false,
        data: ''
      }
    },
    methods: {
      saveData () {
      },
    },
    created: function () {
      let html = localStorage.getItem('preview')
      this.data = html
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (!val) {
          this.$emit('on-close', val)
        }
      },
      previewData (val) {
        this.data = val
      },
    }
  }
</script>



// WEBPACK FOOTER //
// LessonPreview.vue?cab7db04